import Vue from 'vue'
import Vuetify, { VIcon, VSnackbar } from 'vuetify/lib'
import i18n from '@/i18n'
import '@/sass/overrides.sass'

Vue.use(Vuetify, {
  components: {
    // the components which Toast.vue used
    VIcon,
    VSnackbar,
  },
})

const theme = {
  primary: '#3355f6',
  secondary: '#9C27b0',
  accent: '#9C27b0',
  info: '#00CAE3',
  app: '#3355f6',
}

export default new Vuetify({
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },
  theme: {
    dark: true,
    themes: {
      dark: theme,
      light: theme,
    },
  },
})
